/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

window.addEventListener('load', function(event) {

    // Remove css classes from wishlist link in mobile nav intended for main desktop nav, not mobile
    setTimeout(function(){
        jQuery('.SidebarMenu__Nav--secondary .wk-link').each(function(){
            jQuery(this).removeClass('Heading').removeClass('Text--subdued').removeClass('u-h5');
            jQuery(this).closest('.HorizontalList__Item').addClass('Linklist__Item').removeClass('HorizontalList__Item');
        });
    }, 500);

    if (typeof(jQuery)!=='undefined') {
        jQuery('.Popover__ValueList button').on('click', function(){
            setTimeout(function(){
                var optionVal = jQuery('select[name=id] option:selected').data('title');
                if (typeof(optionVal)!=='undefined' && optionVal) {
                    jQuery('input[name=option-0]').each(function(){
                        if (jQuery(this).val()==optionVal) {
                            jQuery(this).trigger('click');
                            this.checked=true;
                        }
                    });
                }
            },100);
        });
    }

});


document.addEventListener('DOMContentLoaded', (event) => {
  const init = () => {
    const url = new URL(window.location.href);
    const title = document.querySelector('.template-product .ProductForm__SelectedValue');
    const button = document.querySelector('.template-product .ProductForm__AddToCart');

    if (!url.searchParams.has('variant')) {
      console.log('URL has no variant selected')
      if (button && !button.hasAttribute('data-has-only-default')) button.setAttribute('disabled', 'disabled')
      if (title) title.textContent = 'Please select a size'
    }
    else {
      console.log('URL has variant selected: ', url.searchParams.get('variant'))
      return
    }
  }
  let mql = window.matchMedia('(max-width: 640px)');
  if (mql.matches) init();
});
